<section id="highlight" [ngClass]="{'invert-colors': invertColors}" [style]="{'backgroundColor': background_color }" [class.iframe-mode]="hideBanner">
    <div class="highlight">
        <div class="highlight__columns">
            <div class="highlight__columns__item" [ngClass]="{'no-image': img === '' || !img}" *ngIf="!hideBanner">
                <div class="highlight__info" [ngClass]="{'no-image-text': img === '' || !img}">
                    <div class="highlight__texts">
                        <h1 *ngIf="title" class="highlight__title" [innerHTML]="title | htmlParse"></h1>
                        <h2 *ngIf="description" class="highlight__subtitle" [innerHTML]="description | htmlParse"></h2>
                        <div *ngIf="disclaimer" class='highlight__disclaimer' [innerHTML]="disclaimer | htmlParse"></div>
                    </div>
                    <div *ngIf="img !== ''" style="width: 100%;">
                        <app-image class="highlight__banner" [path]="img" [alt]="alt_text" title="banner"></app-image>
                    </div>
                    <!-- Newsletters -->
                    <article *ngIf="informationTitle || informationText" class="highlight__information-card">
                        <h2
                            *ngIf="informationTitle"
                            class="highlight__information-card-title"
                            [innerHTML]="informationTitle | htmlParse"
                        ></h2>

                        <div
                            *ngIf="informationText"
                            class="highlight__information-card-text"
                            [innerHTML]="informationText | htmlParse"
                        ></div>
                    </article>
                    <!-- end Newsletters -->
                </div>
            </div>
            <div id="quote-form" class="highlight__columns__item other-bg" [style]="{'backgroundColor': background_color_behind_form }">
                <div class="content">
                    <div class="wrapper-form" [style]="{'backgroundColor': background_color_form }">
                        <div *ngIf="text" class="highlight__title__form" [innerHTML]="text | htmlParse"></div>
                        <ng-content select="[form]"></ng-content>
                    </div>
                    <ng-content select="[ekomi]"></ng-content>
                </div>
            </div>
        </div>
    </div>
</section>
